import { render, staticRenderFns } from "./SubscriberViewSidebar.vue?vue&type=template&id=b2fd2f0e&scoped=true&"
import script from "./SubscriberViewSidebar.vue?vue&type=script&lang=js&"
export * from "./SubscriberViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SubscriberViewSidebar.vue?vue&type=style&index=0&id=b2fd2f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fd2f0e",
  null
  
)

export default component.exports